import React, { useState } from "react"

import createPersistedState from "use-persisted-state"

import Explorer, { LogInOutButton } from "~components/Explorer"
import { withMicrocopy } from "~contexts/MicrocopyContext"

import * as style from "./LoginButton.module.scss"

const LoginButton = ({
  id = "credentials",
  useCreateAppScope = false,
  noWrap = false,
  microcopy,
}) => {
  const usePersistedState = createPersistedState(`com.box.developer.${id}`)
  const [credentials, setCredentials] = usePersistedState({})

  const customClientId = createPersistedState(
    `com.box.developer.${id}.client_id`,
  )(null)[0]

  const explorer = new Explorer({
    endpoint: null,
    useState,
    microcopy,
    credentials,
    setCredentials,
    customClientName: id,
    customClientId,
    useCreateAppScope,
  })

  return (
    <span className={style.button} data-styled={!noWrap} data-loginbutton>
      <LogInOutButton explorer={explorer} microcopy={microcopy} />
    </span>
  )
}

export default withMicrocopy(LoginButton)
